export const RETRIEVE_TOPICS_BEGIN = 'RETRIEVE_TOPICS_BEGIN';
export const RETRIEVE_TOPICS_SUCCESS = 'RETRIEVE_TOPICS_SUCCESS';
export const RETRIEVE_TOPICS_FAILURE = 'RETRIEVE_TOPICS_FAILURE';
export const RETRIEVE_TOPIC_PREVIEW_BEGIN = 'RETRIEVE_TOPIC_PREVIEW_BEGIN';
export const RETRIEVE_TOPIC_PREVIEW_SUCCESS = 'RETRIEVE_TOPIC_PREVIEW_SUCCESS';
export const RETRIEVE_TOPIC_PREVIEW_FAILURE = 'RETRIEVE_TOPIC_PREVIEW_FAILURE';
export const DEFAULT_RETRIEVE_TOPICS_PAGE_ID        = 1;
export const DEFAULT_RETRIEVE_TOPICS_RETRIEVE_LIMIT = 10000;
export const CREATE_TOPICS_BEGIN = 'CREATE_TOPICS_BEGIN';
export const CREATE_TOPICS_SUCCESS = 'CREATE_TOPICS_SUCCESS';
export const CREATE_TOPICS_FAILURE = 'CREATE_TOPICS_FAILURE';
export const UPDATE_TOPICS_BEGIN = 'UPDATE_TOPICS_BEGIN';
export const UPDATE_TOPICS_SUCCESS = 'UPDATE_TOPICS_SUCCESS';
export const UPDATE_TOPICS_FAILURE = 'UPDATE_TOPICS_FAILURE';
export const DELETE_TOPIC_BEGIN = 'DELETE_TOPIC_BEGIN';
export const DELETE_TOPIC_SUCCESS = 'DELETE_TOPIC_SUCCESS';
export const DELETE_TOPIC_FAILURE = 'DELETE_TOPIC_FAILURE';
export const RESET_TOPICS_STATE = 'RESET_TOPICS_STATE';
export const RETRIEVE_CATEGORIES_BEGIN = 'RETRIEVE_CATEGORIES_BEGIN';
export const RETRIEVE_CATEGORIES_SUCCESS = 'RETRIEVE_CATEGORIES_SUCCESS';
export const RETRIEVE_CATEGORIES_FAILURE = 'RETRIEVE_CATEGORIES_FAILURE';
export const UPLOAD_FILE_BEGIN = 'UPLOAD_FILE_BEGIN';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_BEGIN = 'RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_BEGIN';
export const RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_SUCCESS = 'RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_SUCCESS';
export const RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_FAILURE = 'RETRIEVE_ALL_UPLOADED_FILES_FOR_TOPIC_FAILURE';
export const TOPIC_PROCESSED_STATE_READY = "ready";
export const CANNOT_EDIT_CURRENTLY_SELECTED_TOPIC_MSG = "Cannot edit currently selected topic";
export const CANNOT_DELETE_CURRENTLY_SELECTED_TOPIC_MSG = "Cannot delete currently selected topic";
export const BOOLEAN_AND = "and";
export const BOOLEAN_OR  = "or";
export const BOOLEAN_NOT = "not";
export const KEY_FOR_TOPIC_ID      = 'topicId';
export const KEY_FOR_KEYWORDS_JSON = 'keywordsJSON';
export const KEY_FOR_TOPIC_NAME    = 'topicName';
export const KEY_FOR_DESCRIPTION   = 'description';
export const KEY_FOR_CATEGORIES    = 'categories';
export const KEY_FOR_TOPIC_READY_NOTIFICATION_EMAIL_ADDRESS = 'topicReadyNotificationEmailAddress';
export const KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE = 'earliestHistoricalDataDate';
export const KEY_FOR_ESTIMATED_PROCESSING_TIME_IN_HOURS = 'estimatedProcessingTimeInHours';
export const KEY_FOR_HAS_CRAWLED_DATA = 'hasCrawledData';
export const KEY_FOR_HAS_UPLOADED_DATA = 'hasUploadedData';
export const KEY_FOR_FILE_NAME = 'fileName';
export const KEY_FOR_FILE_LANGUAGE = 'language';
export const KEY_FOR_FILE_DATE_UPLOADED = 'dateUploaded';
export const KEY_FOR_DATE_FOR_COMMENTS = 'dateForComments';
export const DEFAULT_PROCESSED_STATUS = 'Not Processed';
export const KEY_FOR_UPLOADED_FILE = 'uploadedFile';
export const SINGAPORE_CATEGORY_NAME = 'Singapore';
export const DEFAULT_EARLIEST_HISTORICAL_DATA_DATE = '2020-07-01';
export const ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE = 'add';
export const ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE = 'addNewUploadDataTopic';
export const REACT_GA_TOPIC_CATEGORY = 'Topic';
export const KEY_FOR_COUNT = 'count';


// WEBPACK FOOTER //
// ./src/features/topics/redux/constants.js